import { render, staticRenderFns } from "./mqualifications.vue?vue&type=template&id=53446f4c"
import script from "./mqualifications.vue?vue&type=script&lang=js"
export * from "./mqualifications.vue?vue&type=script&lang=js"
import style0 from "./mqualifications.vue?vue&type=style&index=0&id=53446f4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports